import Fuse from 'fuse.js';
import { LibraryElement } from '@/GraphEditor/drawingLayer/NodeLibrary/LibraryElement';

function memoize<T extends (...args: any[]) => any>(fn: T): T {
    const cache = new Map();
    return ((...args) => {
        const key = JSON.stringify(args);
        if (cache.has(key)) {
            return cache.get(key);
        } else {
            const result = fn(...args);
            cache.set(key, result);
            return result;
        }
    }) as T;
}

export class LibrarySearch {
    private readonly fuse: Fuse<LibraryElement>;

    constructor(private readonly library: LibraryElement[]) {
        this.fuse = new Fuse(library, {
            includeScore: true,
            threshold: 0.2,
            findAllMatches: true,
            keys: [{ name: 'name', weight: 5 }, { name: 'description', weight: 2 }, 'category'],
        });
    }

    private searchLibraryElements = (search: string): LibraryElement[] => {
        if (search.trim().length === 0) {
            return this.library;
        } else {
            const searchResult = this.fuse.search(search);
            return searchResult.map(r => r.item);
        }
    };

    public searchLibraryElementsMemoized = memoize(this.searchLibraryElements);
}
